const Status = (props) => {
  return (
    <div className={`status-badge _${props.color} ${props.className ? props.className : ""}`}>
      <div className="text-status">{props.children}</div>
    </div>
  );
};

export default Status;
